import { InfoPopover, type InfoPopoverProps } from '@adsk/alloy-react-tooltip'
import React from 'react'

const HighZIndexInfoPopOver = (props: InfoPopoverProps): JSX.Element => {
	const { style, ...restProps } = props
	return (
		<InfoPopover
			container={props?.container ?? <span style={{ zIndex: 100000 }}></span>}
			placement={InfoPopover.PLACEMENTS.RIGHT}
			variant={InfoPopover.VARIANTS.DARK}
			size={15}
			style={
				style ?? {
					margin: '0.2rem auto auto 0.2rem',
					fontWeight: 'bold',
				}
			}
			{...restProps}
		/>
	)
}

export default HighZIndexInfoPopOver
